var _style, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalysisSplashImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 490",
    style: {
      enableBackground: "new 0 0 1080 490"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#E7E6E6;}\r\n\t.st2{fill:#D7D7D7;}\r\n\t.st3{fill:#B8BDC1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 1080,
    height: 490.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M729.1,413.1c-23.3,0-42.2-18.9-42.2-42.2c0-23.3,18.9-42.2,42.2-42.2c23.3,0,42.2,18.9,42.2,42.2 C771.3,394.2,752.4,413.1,729.1,413.1z M729.1,332.4c-21.3,0-38.6,17.3-38.6,38.6c0,21.3,17.3,38.6,38.6,38.6 c21.3,0,38.6-17.3,38.6-38.6C767.7,349.7,750.4,332.4,729.1,332.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M586.6,162.1c-23.3,0-42.2-18.9-42.2-42.2c0-23.3,18.9-42.2,42.2-42.2c23.3,0,42.2,18.9,42.2,42.2 C628.7,143.2,609.8,162.1,586.6,162.1z M586.6,81.4c-21.3,0-38.6,17.3-38.6,38.6c0,21.3,17.3,38.6,38.6,38.6 c21.3,0,38.6-17.3,38.6-38.6C625.1,98.7,607.8,81.4,586.6,81.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.4,372.4c-70.1,0-127.1-57-127.1-127.1s57-127.1,127.1-127.1s127.1,57,127.1,127.1 S356.5,372.4,286.4,372.4z M286.4,121.7c-68.1,0-123.5,55.4-123.5,123.5s55.4,123.5,123.5,123.5s123.5-55.4,123.5-123.5 S354.5,121.7,286.4,121.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M871.5,162.1c-23.3,0-42.2-18.9-42.2-42.2c0-23.3,18.9-42.2,42.2-42.2c23.3,0,42.2,18.9,42.2,42.2 C913.7,143.2,894.7,162.1,871.5,162.1z M871.5,81.4c-21.3,0-38.6,17.3-38.6,38.6c0,21.3,17.3,38.6,38.6,38.6 c21.3,0,38.6-17.3,38.6-38.6C910.1,98.7,892.8,81.4,871.5,81.4z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 586.6,
    cy: 247.7,
    r: 40.4
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 586.6,
    cy: 375.5,
    r: 40.4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 871.5,
    cy: 247.7,
    r: 40.4
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 729,
    cy: 247.7,
    r: 40.4
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 729,
    cy: 124.5,
    r: 40.4
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 871.5,
    cy: 375.5,
    r: 40.4
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M318.9,261.3c-0.7-7.6-7.5-17.5-27.4-21.5v-29.1c11.7,2.2,18.1,14.7,18.1,14.7l7.7-4.8c0,0-5.8-17.3-25.8-19.2 v-10.7H283v10.8c-20,1.8-25.2,14.2-24.6,25.7c0.6,10.5,14,18.4,24.6,21.3v32.1c-13-2.8-19-14.4-20.3-21.4c-6.2,2.7-8.9,4.8-8.9,4.8 s4.2,23.5,29.2,25.8v10h8.6v-10C316.5,287.8,319.7,269,318.9,261.3z M269.1,217.7c1.3-2.9,6-6.6,13.9-7.5v27.9 C264.5,233.8,267.5,221.2,269.1,217.7z M291.6,281.2v-30.9c9.2,2,17.5,6,17.5,14.1C309,272.6,303.3,280.3,291.6,281.2z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M884,126c-0.3-2.9-2.9-6.8-10.6-8.3v-11.2c4.5,0.8,7,5.7,7,5.7l3-1.8c0,0-2.2-6.7-10-7.4v-4.1h-3.3v4.1 c-7.7,0.7-9.7,5.5-9.5,9.9c0.2,4,5.4,7.1,9.5,8.2v12.4c-5-1.1-7.3-5.5-7.8-8.2c-2.4,1-3.4,1.8-3.4,1.8s1.6,9.1,11.3,10v3.9h3.3V137 C883.1,136.2,884.3,129,884,126z M864.8,109.2c0.5-1.1,2.3-2.6,5.3-2.9v10.8C863.1,115.4,864.2,110.6,864.8,109.2z M873.5,133.7 v-11.9c3.5,0.8,6.7,2.3,6.7,5.5C880.2,130.4,878,133.4,873.5,133.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisSplashImage);
export default __webpack_public_path__ + "static/media/AnalysisSplashImage.4c14949e.svg";
export { ForwardRef as ReactComponent };